<template>
  <div>
    <topsearch title="Ana Ekran" />
    <div class="mt-4 md:mt-0 content-section">
      <div class="grid dashboard-menu  grid-cols-2 md:grid-cols-4 gap-2 mb-4">
        <div
          class="border block rounded-lg text-primary-900 p-2"
          v-for="(table, index) in $root.cache.tables"
          v-if="table.location == 1"
          :key="table.id"
        >
          <template v-if="table.url">
            <router-link :to="{ name: table.url, params: { index } }">
              <div class="url">
                <vk-icon
                  class="text-tile-500"
                  ratio="1"
                  :icon="table.icon"
                ></vk-icon>
                <span>{{ table.name }}</span>
              </div>
            </router-link>
          </template>
          <template v-else>
            <router-link
              :to="{ name: 'list', params: { index, table: table.table } }"
            >
              <div class="url">
                <vk-icon
                  class="text-tile-500"
                  ratio="1"
                  :icon="table.icon"
                ></vk-icon>
                <span>{{ table.name }}</span>
              </div>
            </router-link>
          </template>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <vue-cal
            :time="false"
            active-view="month"
            style="min-height:500px"
            label="title"
            :events="events"
            locale="tr"
            :on-event-click="onEventClick"
          ></vue-cal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

import VueCal from "vue-cal";

import http from "../services/http";
import dateVue from "../components/Ui/Search/date.vue";

export default {
  data() {
    return {
      start: "1970-01-01",
      end: "1970-01-01",
      events: [],
      leadstatus_report_options: {
        chartType: "donut",
        series: [],
        options: {
          colors: [],
        },
      },
      leads_report_options: {
        options: {
          chart: {
            id: "vuechart",
          },
          xaxis: {
            categories: [],
          },
        },
        series: [
          {
            name: "Lead Count",
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    setDatepicker(e) {
      this.start = e.value.start;
      this.end = e.value.end;
      //   this.form.start = e.value;

      this.drawCharts();
      this.$forceUpdate();
    },
    drawCharts() {
      http.getReports({ start: this.start, end: this.end }).then((resp) => {
        if (resp.data) {
          this.leadstatus_report_options.options.labels = [];
          this.leadstatus_report_options.series = [];
          this.leads_report_options.options.xaxis.categories = [];
          this.leads_report_options.series[0].data = [];
          resp.data.leads.map((e) => {
            this.leads_report_options.options.xaxis.categories.push(e.date);
            this.leads_report_options.series[0].data.push(e.lead_count);
          });

          resp.data.lead_statuses.map((e) => {
            this.leadstatus_report_options.series.push(parseInt(e.lead_count));
            this.leadstatus_report_options.options.labels.push(e.label);

            this.leadstatus_report_options.options.colors.push(e.background);
          });
        }
      });
    },
    onEventClick(event, e) {
      this.$router.push("/leadDetail/" + event.lead_id);

      e.stopPropagation();
    },
  },
  created() {
    http.getCalendar().then((resp) => {
      this.events = resp.data;
    });
  },
  mounted() {},
  components: {
    apexchart: VueApexCharts,
    VueCal,
    datepicker: dateVue,
  },
};
</script>

<style>
.dashboard-menu .url {
  @apply flex items-center text-primary-900 space-x-2 justify-start;
}

.chart {
  border: 1px solid #eee;
  padding: 10px;
  margin-bottom: 20px;
}

.chart h2 {
  margin: 0px;
  padding: 0px;
  font-size: 17px;
}

.apexcharts-canvas .dark {
  height: auto !important;
}
</style>
